import {useContext} from 'react';
import {observer} from 'mobx-react-lite/dist/index';
import {StoreContext} from '../../helpers/StoreContext'


export default observer( () => {
  const hotelStore = useContext(StoreContext).hotelStore;
  const ltaUserObj = hotelStore.ltaUserCookie;
        
  if ((ltaUserObj)) {
    let doCookie = true;
    const cookieName = 'ltaUser=';
    let pageVal = null;

    if (document.cookie) {
      document.cookie.split(';').some((item) => {
        const indx = item.indexOf(cookieName);
        if (indx > -1) {
            pageVal = item.substr(indx + cookieName.length).trim();
        }

        return indx > -1;
      });
      if (pageVal && pageVal === ltaUserObj.ltaUser) {
        doCookie = false;
      }
    }
    if (doCookie) {
      let domain = '';
      const arr = window.location.hostname.split('.');
      if (arr.length > 1 && isNaN(arr[arr.length-2]) && isNaN(arr[arr.length-1])) {
        domain = '; domain=.' + arr[arr.length-2] + '.' + arr[arr.length-1];
      }

      document.cookie = 'ltaUser=' + ltaUserObj.ltaUser + domain + '; expires = ' + ltaUserObj.expires;
    }
  }

  return '';

});
